export default {"src":"/_next/static/media/document.bedfb764.svg","height":169,"width":130,"blurWidth":0,"blurHeight":0};